import React, { useState } from "react";
import { useFormContext } from "react-hook-form";

import { useGetSearchMoldList } from "../../hooks";
import { HubHookFormSearchField } from "../HubHookFormSearchField";

export const HubHookFormMoldSelect = ({
  locationId = 1,
  label = "Search for Part Mold",
  placeholder = "Search for part...",
  name = "partId",
  defaultValue,
  onChange = () => {},
  disabled,
  ...rest
}) => {
  const [search, setSearch] = useState();
  const { getValues } = useFormContext();
  const defaultPartId = defaultValue || getValues(name);

  const { data } = useGetSearchMoldList({
    search,
    partId: defaultPartId,
    locationId,
  });

  return (
    <HubHookFormSearchField
      name={name}
      label={label}
      placeholder={placeholder}
      defaultValue={defaultPartId}
      options={data || []}
      value={search}
      setValue={setSearch}
      onChange={onChange}
      disabled={disabled}
      debounceTime={500}
      rows={2}
      multiline
      {...rest}
    />
  );
};

export default HubHookFormMoldSelect;
